import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const localUser = JSON.parse(localStorage.getItem('techtop_rep_user'));
  const [user, setUser] = useState(localUser);

  const login = (userData) => {
    localStorage.setItem('techtop_rep_user', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('techtop_rep_user');
    setUser(null);
    setTimeout(() => {
      window.location.reload();
    }, 50);
  };

  const updateCustomers = (customers) => {
    const updatedUser = { ...user, customers };
    localStorage.setItem('techtop_rep_user', JSON.stringify(updatedUser));
    setUser(updatedUser);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, updateCustomers }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => useContext(AuthContext);